module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAA4CAYAAABZjWCTAAAAgUlEQVRoge3auw3AIAwAURNlFvZfx16GVCmp8kGH7rWWkE9uaZk5YlPH6gW+ZByVcVTGURlHZRyVcVTGURlHZRyVcVTGURlHZRyVcVTGURlHZRyVcVRnRLTVSzzRe5/Otr/cG/9Q7uv//lZVTWdbX844KuOojKMyjso4KuOojKO6AIyiCf4d2PzvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/stacked.png
// module id = owPp
// module chunks = 0